import { effectiveApiBase } from "@/lib/apiBase";

function trimOrigin(raw: string): string {
  return raw.trim().replace(/\/$/, "");
}

/**
 * 会員向け Web アプリのオリジン（ブックマーク・案内用）。
 * 本番では `VITE_WEB_APP_ORIGIN` を推奨。未設定時は現在のページの origin。
 */
export function webAppOrigin(): string {
  const fromEnv = trimOrigin(import.meta.env.VITE_WEB_APP_ORIGIN ?? "");
  if (fromEnv) return fromEnv;
  if (typeof window === "undefined") return "";
  return window.location.origin;
}

/** 店舗用 `/staff` のフル URL */
export function staffPageUrl(): string {
  const base = webAppOrigin();
  if (!base) return "/staff";
  return `${base}/staff`;
}

/**
 * QR に埋め込む `…/api/qr/{token}` のオリジン。
 * API とフロントが別ドメインの本番では API 側（`VITE_API_BASE_URL`）を使う必要がある。
 */
export function qrEmbedOrigin(): string {
  const explicit = trimOrigin(import.meta.env.VITE_QR_EMBED_ORIGIN ?? "");
  if (explicit) return explicit;
  const api = trimOrigin(effectiveApiBase());
  if (api) return api;
  if (typeof window === "undefined") return "";
  return window.location.origin;
}
